require('./taxAdditionalCountryEdit.scss');

// @vendor
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// @commons
const { FormattedText } = require('core/i18n').i18n;
import { InputSafe } from 'commonsComponents/inputSafe';
import { OKButton } from 'components/commons/OKButton/OKButton';
import OKSelect from 'components/commons/OKSelect/OKSelect';
import { OKTextArea } from 'commonsComponents/OKTextArea';
// @components
import TaxAdditionalCountryData from 'components/myProfile/taxAdditionalCountryList/taxAdditionalCountryData';
// @constants
import TAXING_REASONS from 'constants/taxingReason';
import { validateTin } from 'actions/tinValidation';

class TaxAdditionalCountryEdit extends React.Component {
    constructor(props) {
        super(props);
        const { immCountry, isNew } = this.props;
        this.state = {
            editing: isNew,
            countryCode: immCountry.get('paisTributacion'),
            countryCodeDirty: false,
            countryCodeValid: true,
            taxingCountryDocumentID: immCountry.get('tin').get('codigodocumpersonacorp').trim(),
            taxingCountryDocumentIDDirty: false,
            taxingCountryDocumentText: "",
            taxingCountryDocumentTextDirty: false,
            taxingCountryDocumentIDValid: true,
            taxingReasonCode: immCountry.get('indTipoTributacion') ? immCountry.get('indTipoTributacion').trim() : null,
            taxingReasonCodeDirty: false,
            taxingReasonCodeValid: true
        };
    }

    async componentDidMount() {
        const { countryCode, taxingCountryDocumentID } = this.state;
        const { onHandleNextDisableButton } = this.props;
        const validTin = await validateTin(countryCode, taxingCountryDocumentID)

        if (!validTin) onHandleNextDisableButton(!validTin);
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ taxingCountryDocumentIDValid: validTin, taxingCountryDocumentIDDirty: true });
    }

    handleTextAreaChange = evt => {
        this.setState({
            taxingCountryDocumentText: evt.target.value,
            taxingCountryDocumentTExtDirty: true
        });
    }

    handleCancel = () => {
        const { immCountry, index, onCancelNewCountry, setEditingTaxAdditionalCountry } = this.props;
        setEditingTaxAdditionalCountry && setEditingTaxAdditionalCountry(false, index);
        this.setState({
            editing: false,
            countryCode: immCountry.get('paisTributacion'),
            countryCodeDirty: false,
            countryCodeValid: true,
            taxingCountryDocumentID: immCountry.get('tin').get('codigodocumpersonacorp'),
            taxingCountryDocumentIDDirty: false,
            taxingCountryDocumentIDValid: true,
            taxingCountryDocumentText: "",
            taxingCountryDocumentTextDirty: false,
            taxingReasonCode: immCountry.get('indTipoTributacion'),
            taxingReasonCodeDirty: false,
            taxingReasonCodeValid: true
        });
        if (typeof onCancelNewCountry !== 'undefined') {
            onCancelNewCountry();
        }
    }

    handleSaveCountry = () => {
        const { index, onSaveCountry, setEditingTaxAdditionalCountry } = this.props
        const { countryCode, taxingReasonCode, taxingCountryDocumentID, taxingCountryDocumentText } = this.state;
        const isValidTaxingCountryDocumentID = ((taxingCountryDocumentID && taxingCountryDocumentID.trim().length > 1) || taxingCountryDocumentText.trim().length > 1);
        if (countryCode && taxingReasonCode && isValidTaxingCountryDocumentID) {
            const data = {
                countryCode,
                taxingReasonCode,
                taxingCountryDocumentText,
                taxingCountryDocumentID
            };
            this.setState({
                editing: false,
                countryCodeDirty: false,
                countryCodeValid: true,
                taxingCountryDocumentIDDirty: false,
                taxingCountryDocumentIDValid: true,
                taxingCountryDocumentText: "",
                taxingCountryDocumentTextDirty: false,
                taxingReasonCodeDirty: false,
                taxingReasonCodeValid: true
            });
            setEditingTaxAdditionalCountry && setEditingTaxAdditionalCountry(false, index);
            onSaveCountry(index, data);
        }
        else  {
            this.setState({
                countryCodeValid: !!countryCode,
                taxingReasonCodeValid: !!taxingReasonCode,
                taxingCountryDocumentIDValid: isValidTaxingCountryDocumentID,
                countryCodeDirty: false,
                taxingCountryDocumentIDDirty: false,
                taxingReasonCodeDirty: false
            });
        }
    }

    buildFormEditable = () => {
        const { tinLength, addNoTin } = this.props;
        const TAXING_REASONS_OPTIONS = Object.getOwnPropertyNames(TAXING_REASONS()).map(property => ({ value: property, label: TAXING_REASONS()[property]}));
        const {
            countryCode,
            countryCodeDirty,
            countryCodeValid,
            taxingCountryDocumentID,
            taxingCountryDocumentIDDirty,
            taxingCountryDocumentText,
            taxingCountryDocumentIDValid,
            taxingReasonCode,
            taxingReasonCodeDirty,
            taxingReasonCodeValid
         } = this.state;

        return (
            <div className="country-edit__edit-section">
                <div className="row country-edit__input-section">
                    <div className="col-xs-6 padding-top">
                        <OKSelect
                            name="field-country"
                            label={<FormattedText value="profile-countrySelectLabel"/>}
                            matchPos="start"
                            matchProp="label"
                            noResultsText={<FormattedText value="profile-selectNotFound"/>}
                            placeholder={<FormattedText value="profile-selectPlaceholder"/>}
                            options={this.props.countriesAvailbles}
                            value={countryCode}
                            searchable={true}
                            clearable={false}
                            onChange={this.handleSelectCountryChange}
                            errorState={!countryCodeValid && !countryCodeDirty}
                            errorMessage={<FormattedText value="profile-incompleteCountryCode"/>}
                        />
                    </div>
                    <div className="col-xs-6 padding-top">
                        <OKSelect
                            name="field-taxingReason"
                            label={<FormattedText value="profile-reasonSelectLabel"/>}
                            matchPos="start"
                            matchProp="label"
                            noResultsText={<FormattedText value="profile-selectNotFound"/>}
                            placeholder={<FormattedText value="profile-selectPlaceholder"/>}
                            options={TAXING_REASONS_OPTIONS}
                            value={taxingReasonCode}
                            searchable={false}
                            clearable={false}
                            onChange={this.handleSelectTaxingReasonChange}
                            errorState={!taxingReasonCodeValid && !taxingReasonCodeDirty}
                            errorMessage={<FormattedText value="profile-incompleteTaxingReasonCodeValid"/>}
                        />
                    </div>
                    <div className="col-xs-12 padding-top">
                        <InputSafe
                            label={<FormattedText value="profile-tinInputLabel"/>}
                            name="taxingCountryDocumentID"
                            type="text"
                            value={taxingCountryDocumentID}
                            onChange={this.handleTinChange}
                            errorState={!taxingCountryDocumentIDValid}
                            errorMessage={!taxingCountryDocumentIDValid && taxingCountryDocumentIDDirty ? <FormattedText value="profile-invalidTaxingDocumentID"/> : <FormattedText value="profile-incompletetaxingCountryDocumentID"/>}
                            maxLength={tinLength}
                            onKeyPress={this.handleRegexOnKeyPressAndPaste}
                            onPaste={this.handleRegexOnKeyPressAndPaste}
                        />
                    </div>
                    {addNoTin &&
                        <div className="col-xs-12">
                            <OKTextArea
                                customClass="country-edit__input-section__textarea"
                                onChange={this.handleTextAreaChange}
                                value={taxingCountryDocumentText}
                                placeholder={<FormattedText value="profile-noTinPlaceholder"/>}
                                errorState={!taxingCountryDocumentIDValid && !taxingCountryDocumentText}
                            />
                        </div>
                    }
                </div>
                <div className="row no-outside-gutter">
                    <div className="country-edit__buttons-container">
                        <OKButton modifier="ghost" size="small"
                            onClick={this.handleCancel}>
                            <FormattedText value="profile-profileCancelButtonLabel"/>
                        </OKButton>
                        {this.state.taxingCountryDocumentIDValid &&
                            <OKButton modifier="secondary" size="small"
                                onClick={this.handleSaveCountry}>
                                <FormattedText value="profile-profileSaveButtonLabel"/>
                            </OKButton>
                        }
                    </div>
                </div>
            </div>
        );
    }

    handleTinChange = evt => {
        const TINInput = evt.target.value.trim();

        this.setState({
            taxingCountryDocumentID: TINInput,
            taxingCountryDocumentIDDirty: true
        }, async () => {
            await this.taxationDocumentValidationWithCountry(this.state.countryCode, TINInput);
        });
    }

    handleSelectCountryChange = newCountryCode => {
        this.setState({
            countryCode: newCountryCode.value,
            countryCodeDirty: true
        }, async () => {
            await this.taxationDocumentValidationWithCountry(newCountryCode.value, this.state.taxingCountryDocumentID);
        });
    }

    handleSelectTaxingReasonChange = newTaxingReasonCode => {
        const { taxingCountryDocumentID, countryCode } = this.state;

        this.setState({
            taxingReasonCode: newTaxingReasonCode.value,
            taxingReasonCodeDirty: true
        }, async () => {
            await this.taxationDocumentValidationWithCountry(countryCode, taxingCountryDocumentID);
        });
    }

    taxationDocumentValidationWithCountry = async (country, taxDocument) => {
        const { onHandleNextDisableButton } = this.props;
        const TINResponse = await validateTin(country, taxDocument);
        this.setState({ taxingCountryDocumentIDValid: TINResponse })
        onHandleNextDisableButton(!TINResponse)
    }

    handleDeleteCountry = () => {
        const { onDeleteCountry, index } = this.props;
        onDeleteCountry(index);
    }

    handleEditing = () => {
        const { index, setEditingTaxAdditionalCountry } =  this.props;
        setEditingTaxAdditionalCountry && setEditingTaxAdditionalCountry(true, index);
        this.setState({editing: true});
    }

    handleRegexOnKeyPressAndPaste = event => {
       const { tinRegex } = this.props;
       const regexText = event.clipboardData
           ? event.clipboardData.getData('text/plain')
           : String.fromCharCode(event.charCode);

       if (tinRegex && !tinRegex.test(regexText) && !event.ctrlKey) {
           event.preventDefault();
       }
   }

    render = () => {
        const {disableEdit, disableRemove, disableBorderBottom} = this.props
        const containerClassName = classnames('country-edit__container', {
            'country-edit__container--no-border-bottom': disableBorderBottom
        });

        let content = (
            <div className={containerClassName}>
                <section className="country-edit__row">
                    <TaxAdditionalCountryData
                        className="country-edit__data"
                        immCountry={this.props.immCountry}
                    />
                    {!disableEdit &&
                        <div className="country-edit__controls">
                            <OKButton modifier="task" onClick={this.handleDeleteCountry}>
                                <i className="icon-eliminar country-edit__icon" />
                            </OKButton>
                        </div>
                    }
                    {!disableRemove &&
                        <div className="country-edit__controls">
                            <OKButton modifier="task" onClick={this.handleEditing}>
                                <i className="icon-editar country-edit__icon" />
                            </OKButton>
                        </div>
                    }
                </section>
            </div>
        );
        if (this.state.editing) {
            content = this.buildFormEditable();
        }

        return (
            <div>
                {content}
            </div>
        );
    }
}

TaxAdditionalCountryEdit.defaultProps = {
    maxLength: 15
}

TaxAdditionalCountryEdit.propTypes = {
    immCountry: PropTypes.object,
    index: PropTypes.number,
    onDeleteCountry: PropTypes.func.isRequired,
    onCancelNewCountry: PropTypes.func,
    onSaveCountry: PropTypes.func.isRequired,
    countriesAvailbles: PropTypes.array,
    isNew: PropTypes.bool,
    disableEdit: PropTypes.bool,
    disableRemove: PropTypes.bool,
    disableBorderBottom: PropTypes.bool,
    addNoTin:  PropTypes.bool,
    tinLength: PropTypes.number,
    tinRegex: PropTypes.any,
    setEditingTaxAdditionalCountry: PropTypes.func,
    onHandleNextDisableButton: PropTypes.func
};

module.exports = TaxAdditionalCountryEdit;